import fetch from 'services/request';
import { CreateGiftCardBody, GetGiftCardListParams, IAddManUalGiftCardBody, UpdateGiftCardBody } from './constants';

const API_V1 = '/api/v1';
const GIFT_CARD_BASE_URL = API_V1 + '/gift-card';

const giftCardApis = {
  giftCard: {
    getList: (params: GetGiftCardListParams) =>
      fetch({
        method: 'get',
        url: `${GIFT_CARD_BASE_URL}/list`,
        params,
      }),

    getDetail: (id: string) =>
      fetch({
        method: 'get',
        url: `${GIFT_CARD_BASE_URL}/detail/${id}`,
      }),

    resetGiftCard: (ids: string[]) =>
      fetch({
        method: 'post',
        url: `${GIFT_CARD_BASE_URL}/reset`,
        body: ids,
      }),

    create: (data: CreateGiftCardBody) =>
      fetch({
        method: 'post',
        url: `${GIFT_CARD_BASE_URL}/create`,
        body: data,
      }),

    update: (data: UpdateGiftCardBody) =>
      fetch({
        method: 'put',
        url: `${GIFT_CARD_BASE_URL}/update`,
        body: data,
      }),

    delete: (id: string) =>
      fetch({
        method: 'delete',
        url: `${GIFT_CARD_BASE_URL}/delete/${id}`,
      }),

    getSummary: () =>
      fetch({
        method: 'get',
        url: `${GIFT_CARD_BASE_URL}/summary`,
      }),
    getCustomersFilter: (lastPhoneNumber: string) =>
      fetch({
        method: 'get',
        url: '/api/v1/customer/list',
        params: { keySearch: lastPhoneNumber },
      }),
    addManualGiftCard: (body: IAddManUalGiftCardBody) =>
      fetch({
        method: 'post',
        url: '/api/v1/gift-card/add-manual',
        body,
      })
  },
  getInitialCustomers: () =>
    fetch({
      method: 'get',
      url: '/api/v1/customer/list',
      params: { page: 1, size: 10 },
    })
};

export default giftCardApis;
